import React from "react";

const SearchBar = ({
    searchTerm,
    onSearchChange,
    suggestions = [],
    onSuggestionClick,
    placeholder = "Search...",
    setCurrentPage, // optional: if provided, resets the page on search change
}) => {
    const handleChange = (e) => {
        onSearchChange(e.target.value);
        if (setCurrentPage) {
            setCurrentPage(1);
        }
    };

    return (
        <div className="search-container">
            <input
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={handleChange}
            />
            {suggestions.length > 0 && searchTerm && (
                <ul className="suggestions">
                    {suggestions.map((item, idx) => (
                        <li key={idx} onClick={() => onSuggestionClick(item)}>
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SearchBar;
